import type { NodeProps, Node } from '@xyflow/react'
import { BaseFlowNode } from './node.base'
import type { NodeDataBase } from '../types'

type GenericNodeType = Node<NodeDataBase<{ name: string }>>

export const GenericNode = ({ id, data }: NodeProps<GenericNodeType>) => (
  <BaseFlowNode
    id={id}
    name={data.config.name}
    description={data.config.description}
    meta={data.meta}
  />
)
